<template>
  <div class="row">
    <div class="col-12">
      <div class="custom-table rte-text">
        <CustomTable>
          <table style="width: 100%; min-width: 800px">
            <thead>
              <tr>
                <th scope="col">
                  {{
                    $textDictionary[
                      'downloadCenterSoftware.operationSystemTableLabel'
                    ] ?? 'downloadCenterSoftware.operationSystemTableLabel'
                  }}
                </th>
                <th scope="col">
                  {{
                    $textDictionary[
                      'downloadCenterSoftware.formatTableLabel'
                    ] ?? 'downloadCenterSoftware.formatTableLabel'
                  }}
                </th>
                <th v-if="hasFurtherDownloads" scope="col">
                  {{
                    $textDictionary[
                      'downloadCenterSoftware.furtherDownloadsTableLabel'
                    ] ?? 'downloadCenterSoftware.furtherDownloadsTableLabel'
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="asset of softwareLinks" :key="asset.os.name">
                <tr>
                  <td class="nowrap" style="max-width: 500px">
                    <Button
                      class="custom-button-link"
                      style-type="link"
                      icon-type="icon-left"
                      :icon-name="
                        asset.os.icon === 'macOs' ? 'mac' : asset.os.icon
                      "
                      @click="emits('selectDownload', asset)"
                    >
                      {{ asset.os.name }}
                    </Button>
                  </td>
                  <td class="nowrap">
                    <Button
                      style-type="link"
                      class="custom-button-link"
                      icon-type="icon-left"
                      :icon-name="asset.format.icon"
                      @click="emits('selectDownload', asset)"
                    >
                      {{ asset.format.fileExtension }} </Button
                    >,
                    {{ asset.format.readableFilesize }}
                  </td>
                  <td v-if="hasFurtherDownloads">
                    <template
                      v-for="singleDownload of asset.furtherDownloads"
                      :key="singleDownload.label"
                    >
                      <Button
                        style-type="link"
                        class="custom-button-link"
                        icon-type="icon-left"
                        :icon-name="asset.format.icon"
                        @click="
                          emits(
                            'forceDownloadAndShowSuccess',
                            singleDownload.uri,
                            singleDownload.label ?? 'no_label_found'
                          )
                        "
                      >
                        {{ singleDownload.label }}
                      </Button>
                      <br />
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </CustomTable>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  Button,
  Table as CustomTable
} from '@hypercodestudio/basler-components';

const { $textDictionary } = useNuxtApp();

const emits = defineEmits<{
  selectDownload: [asset: SoftwareLinks];
  forceDownloadAndShowSuccess: [uri: string, softwareName: string];
}>();

type SoftwareLinks = {
  formRequired: boolean;
  os: {
    icon?: string;
    name: string;
    nameEN: string;
    uri?: string;
  };
  format: {
    icon: 'download';
    fileExtension?: string;
    readableFilesize?: string;
    uri: string;
  };
  furtherDownloads: FurtherDownloads[];
};

type FurtherDownloads = {
  label?: string;
  labelEN?: string;
  uri: string;
};

interface Props {
  softwareLinks: SoftwareLinks[];
  softwareId: string;
}

const props = defineProps<Props>();

const hasFurtherDownloads = computed(() =>
  props.softwareLinks.some((asset) => asset.furtherDownloads.length > 0)
);
</script>
